// extracted by mini-css-extract-plugin
module.exports = {"search-results":"_20ccN3BAadkw7D4rmurmH6"};